import React from 'react';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import Divider from 'material-ui/Divider';
import ExpansionPanel, {ExpansionPanelDetails, ExpansionPanelSummary,} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

import Input, {InputAdornment, InputLabel} from 'material-ui/Input';
import { Select, TextField, withValidatedInputs, Validations } from '../../../../components/forms';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';

import {Done, Close} from 'material-ui-icons';

import Grid from 'material-ui/Grid';

import axios from 'axios';
import tsl from './../../../tsl';

import Immutable from 'immutable';
import {DateTimePicker} from "material-ui-pickers";
import {getSettings} from "../../../../utils/client";
import moment from 'moment-timezone';

class Editation extends React.Component {
    state = {
        panelIndex: 0,
        entity: {},
        transfer_flights: [],
        aircrafts: [],
        selectedAircraft: [],
    };

    componentWillMount() {
        this.setEntity(this.props.entityData);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.entityData !== newProps.entityData) {
            this.setEntity(newProps.entityData);
        }
    }

    setEntity(entityData) {
        // create deep copy so the cancel button works correctly
        entityData = Immutable.fromJS(entityData).toJS();
        entityData['start_time'] =  moment().format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            panelIndex: 0,  // show 1st panel
            entity: entityData,
        })
    }

    componentDidMount() {
        
        axios.get('/api/operator/flight/transfers')
            .then((res) => {
                this.setState({transfer_flights: res.data});
            });
    }

    togglePanel = (panelIndex) => () => {
        this.setState({
            panelIndex: (panelIndex == this.state.panelIndex) ? null : panelIndex
        })
    };

    closeEditation = () => {
        // reset entity
        this.setEntity(this.props.entityData);

        this.props.closeEditation();
        this.props.resetFormErrors();
    };

    handleChange = event => {
        let entity = this.state.entity;
        entity[event.target.name] = event.target.value;
        this.setState({entity: entity});
    };

    handleDateTimeChange = (attr) => (date) => {
        let entity = this.state.entity;
        entity[attr] = date.format('YYYY-MM-DD HH:mm:ss');
        this.setState({entity: entity});
    }

    handleChangeRelation = event => {
        let prop = event.target.name;

        let entity = this.state.entity;
        entity[prop] = { id: event.target.value };
        if (prop == 'flight') {
            this.loadAircrafts(event.target.value)
        }
        if (prop == 'aircraft') {
            this.setAircraftAttributes(event.target.value)
        }
        this.setState({entity: entity});


    };

    loadAircrafts(flightOfferId) {
        axios.get('/api/operator/flight/aircrafts/' + flightOfferId)
            .then((res) => {
                this.setState({aircrafts: res.data});
            });
    }

    setAircraftAttributes(aircraftId) {
        var selectedAircraft = this.state.aircrafts.find(aircraft => aircraft.id === aircraftId)
        let entity = this.state.entity;
        entity['passengers_min'] = selectedAircraft.passengers_min;
        entity['price_exclusive'] = selectedAircraft.price_exclusive;
        entity['price_passenger'] = selectedAircraft.price_passenger;
        entity['currency_code'] = selectedAircraft.currency_code;
        this.setState({entity: entity});
    }


    handleSave = () => {
        if (this.props.trySubmit()) {
            this.props.saveEntity(this.state.entity);
            this.props.resetFormErrors();
        }
    };


    renderEntityInformationForm() {

        if (!this.state.entity) {
            return null;
        }
        return (
            <Grid container spacing={24}>
                <Grid item xs={12} sm={6}>
                    
                    <FormControl fullWidth>
                      <InputLabel htmlFor="flight">{tsl('flights.form.transfer_flight')}</InputLabel>
                      <Select
                        formActions={this.props.formActions}
                        required
                        name="flight"
                        value={this.state.entity && this.state.entity.flight ? this.state.entity.flight.id : 0}
                        onChange={this.handleChangeRelation}
                      >
                        <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                        {this.state.transfer_flights.map((flight) => {
                            return (<MenuItem key={flight.id} value={flight.id}>{flight.title}</MenuItem>);
                        })}
                      </Select>
                    </FormControl>
                    <br /><br />

                    <FormControl fullWidth>
                      <InputLabel htmlFor="aircraft">{tsl('flights.form.aircraft')}</InputLabel>
                      <Select
                        formActions={this.props.formActions}
                        required
                        name="aircraft"
                        value={this.state.entity && this.state.entity.aircraft ? this.state.entity.aircraft.id : 0}
                        onChange={this.handleChangeRelation}
                      >
                        <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                        {this.state.aircrafts.map((aircraft) => {
                            return (<MenuItem key={aircraft.id} value={aircraft.id}>{aircraft.aircraft_model.name}</MenuItem>);
                        })}
                      </Select>
                    </FormControl>
                    <br /><br />
                    <div className={`jr-card-header-color text-center`}>
                        <div className="jr-card-hd-content text-white">
                            <br />
                            <DateTimePicker
                                fullWidth
                                label={tsl('flights.form.start_time')}
                                value={this.state.entity.start_time}
                                onChange={this.handleDateTimeChange('start_time')}
                                format="LLL"
                                showTabs={false}
                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                ampm={getSettings('ampm', false)}
                            />
                        </div>
                    </div>
                    <br /><br />
                    <TextField
                        formActions={this.props.formActions}
                        validations={[
                            Validations.isNumeric
                        ]}
                        required
                        fullWidth
                        name="passengers_min"
                        value={this.state.entity.passengers_min || ''}
                        onChange={this.handleChange}
                        label={tsl('offers.edit.minimum_to_fly')}
                        InputProps={{endAdornment:
                                <InputAdornment position="end">{tsl('offers.edit.persons_suffix')}</InputAdornment>}}
                        margin="normal"
                        className="mt-1"
                    />
                    <br/><br/>
                    <TextField
                        formActions={this.props.formActions}
                        validations={[
                            Validations.isNumeric
                        ]}
                        fullWidth
                        name="price_exclusive"
                        value={this.state.entity.price_exclusive || ''}
                        onChange={this.handleChange}
                        label={this.state.entity.price_exclusive ? tsl('offers.edit.exclusive_price') :  tsl('offers.edit.type_price_to_enable_exclusive')}
                        helperText={this.state.entity.price_exclusive ? tsl('offers.edit.leave_empty_to_disable_exclusive') : " "}
                        InputProps={{startAdornment:
                                <InputAdornment position="start">{this.state.entity.currency_code || '-'}</InputAdornment>}}
                        margin="normal"
                        className="mt-1"
                    />

                    <TextField
                        formActions={this.props.formActions}
                        validations={[
                            Validations.isNumeric
                        ]}
                        fullWidth
                        name="price_passenger"
                        value={this.state.entity.price_passenger || ''}
                        onChange={this.handleChange}
                        label={this.state.entity.price_passenger ? tsl('offers.edit.per_seat_price') : tsl('offers.edit.type_price_to_enable_per_seat')}
                        helperText={this.state.entity.price_passenger ? tsl('offers.edit.leave_empty_to_disable_per_seat') : " "}
                        InputProps={{startAdornment:
                                <InputAdornment position="start">{this.state.entity.currency_code || '-'}</InputAdornment>}}
                        margin="normal"
                        className="mt-1"
                    />

                </Grid>

            </Grid>
        );
    }

    render() {
        return (
            <div className="w-100">

                <Button fab raised color="accent"
                    className="jr-fab-btn text-white"
                    style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                    onClick={this.handleSave}
                >
                    <Done />
                </Button>

                <Button fab raised
                    className="jr-fab-btn jr-btn-fab-sm text-white"
                    style={{position: "fixed", bottom: 5, right: 70, zIndex: 9999}}
                    onClick={() => {this.closeEditation()}}
                >
                    <Close />
                </Button>

                <ExpansionPanel expanded={this.state.panelIndex === 0} onChange={this.togglePanel(0)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('flights.form.create_empty_leg')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        {this.renderEntityInformationForm()}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
        );
    }
}

export default withValidatedInputs(Editation);


// WEBPACK FOOTER //
// ./app/used/flights/routes/Editation.js